module.exports = __webpack_public_path__ + "static/media/iros2023_paper.0c38c4e3.gif";